import { Card } from '@/lib/v3/components/Card';

const Skeleton = () => {
  return (
    <div className="grid w-full grid-cols-3 gap-4" role="status">
      <Card id="card-activity-skeleton-1">
        <Card.Header>
          <div className="mb-2.5 h-2.5 w-24 rounded-full bg-gray-300 "></div>
        </Card.Header>
        <Card.Content>
          <div className="mb-2.5 h-2.5 w-24 rounded-full bg-gray-300 "></div>
          <div className="h-2 w-32 rounded-full bg-gray-200 "></div>
        </Card.Content>
      </Card>
      <Card id="card-activity-skeleton-2">
        <Card.Header>
          <div className="mb-2.5 h-2.5 w-24 rounded-full bg-gray-300 "></div>
        </Card.Header>
        <Card.Content>
          <div className="mb-2.5 h-2.5 w-24 rounded-full bg-gray-300 "></div>
          <div className="h-2 w-32 rounded-full bg-gray-200 "></div>
        </Card.Content>
      </Card>
      <Card id="card-activity-skeleton-3">
        <Card.Header>
          <div className="h-2 w-32 rounded-full bg-gray-200 "></div>
        </Card.Header>
        <Card.Content>
          <div className="mb-2.5 h-2.5 w-24 rounded-full bg-gray-300 "></div>
          <div className="h-2 w-32 rounded-full bg-gray-200 "></div>
        </Card.Content>
      </Card>
    </div>
  );
};

export default Skeleton;
